import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import studentId from '../config';
import { FaUser, FaIdCard, FaGraduationCap, FaCalendarAlt, FaSpinner } from 'react-icons/fa';

const Studentinfo = () => {
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Fetch student data from the backend API
useEffect(() => {
  const studentId = localStorage.getItem("studentId");
  const sessionId = localStorage.getItem("currentSessionId");

  if (!studentId || !sessionId) return;

  const fetchStudent = async () => {
    console.log("studentId from LS:", studentId);
    console.log("sessionId from LS:", sessionId);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents/${studentId}`,
        { params: { sessionId } }
      );
      setStudent(response.data);
    } catch (err) {
      console.error("Error fetching student:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchStudent();
}, []);


  if (loading) {
    return (
      <div className="max-w-full mx-auto my-2 bg-white shadow-md rounded-lg ">
        <div className="flex items-center justify-center h-12">
          <FaSpinner className="animate-spin text-blue-500 text-lg mr-2" />
          <p className="text-gray-500 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-full mx-auto my-2 bg-white shadow-md rounded-lg p-3">
        <div className="flex items-center justify-center text-red-500">
          <FaUser className="mr-2" />
          <p className="text-sm">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-full mx-auto my-2 bg-white shadow-md rounded-lg overflow-hidden">
      {/* Compact header with profile image */}
      <div className="flex items-center p-3 bg-gradient-to-r from-blue-500 to-indigo-500">
        <img
          className="w-10 h-10 rounded-full border-2 border-white shadow object-cover"
          src={student.image}
          alt={`${student.firstName} ${student.lastName}`}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "https://via.placeholder.com/150?text=S";
          }}
        />
        <div className="ml-3">
          <h2 className="text-base font-semibold text-white">
            {student.firstName} {student.lastName}
          </h2>
          <p className="text-white text-xs">ID: {student.rollNo}</p>
        </div>
      </div>

      {/* Information rows */}
      <div className="grid grid-cols-2 gap-2 p-3 text-sm">
        <div className="flex items-center">
          <FaGraduationCap className="text-blue-500 mr-2" />
          <div>
            <p className="text-xs text-gray-500">Class</p>
            <p className="font-medium">{student.class}</p>
          </div>
        </div>
        
        <div className="flex items-center">
          <FaIdCard className="text-blue-500 mr-2" />
          <div>
            <p className="text-xs text-gray-500">Section</p>
            <p className="font-medium">{student.section}</p>
          </div>
        </div>
        
        <div className="flex items-center">
          <FaCalendarAlt className="text-blue-500 mr-2" />
          <div>
            <p className="text-xs text-gray-500">Roll No</p>
            <p className="font-medium">{student.rollNo}</p>
          </div>
        </div>
        
        <div className="flex items-center">
          <FaUser className="text-blue-500 mr-2" />
          <div>
            <p className="text-xs text-gray-500">Status</p>
            <p className="font-medium">Active</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Studentinfo;